import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const STUDY_PLAN_ICON_GRADIENT = 'navigationStudyPlanGradient';

export const StudyPlanIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="-2 -1 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath d="M3.7998 20.8C5.45666 20.8 6.7998 19.4568 6.7998 17.8C6.7998 16.1431 5.45666 14.8 3.7998 14.8C2.14295 14.8 0.799805 16.1431 0.799805 17.8C0.799805 19.4568 2.14295 20.8 3.7998 20.8Z" />
      <SPath d="M6.7998 17.8H15.2998C16.2281 17.8 17.1183 17.4312 17.7747 16.7749C18.4311 16.1185 18.7998 15.2282 18.7998 14.3C18.7998 13.3717 18.4311 12.4815 17.7747 11.8251C17.1183 11.1687 16.2281 10.8 15.2998 10.8H4.2998C3.37155 10.8 2.48131 10.4312 1.82493 9.77486C1.16855 9.11848 0.799805 8.22825 0.799805 7.29999C0.799805 6.37173 1.16855 5.48149 1.82493 4.82511C2.48131 4.16874 3.37155 3.79999 4.2998 3.79999H12.7998" />
      <SPath d="M15.7998 6.79999C17.4567 6.79999 18.7998 5.45684 18.7998 3.79999C18.7998 2.14313 17.4567 0.799988 15.7998 0.799988C14.143 0.799988 12.7998 2.14313 12.7998 3.79999C12.7998 5.45684 14.143 6.79999 15.7998 6.79999Z" />
      <defs>
        <linearGradient
          id={STUDY_PLAN_ICON_GRADIENT}
          x1="15.7264"
          y1="23.3881"
          x2="2.93599"
          y2="-0.274178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A37A" />
          <stop offset="1" stopColor="#4FE3A1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SPath = styled.path`
  stroke: #a5aac5;

  ${onLightTheme`
    stroke: rgb(var(--ln-content) / 0.6);
  `}
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;

  .active & {
    stroke: url(#${STUDY_PLAN_ICON_GRADIENT});
  }
`;
